import React, {Component} from 'react';
import WhitePortlet from '../utils/WhitePortlet';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import * as api from '../../api/management-api';
import * as blockUtils from '../../utils/BlockUtils';
import {selectedSiteId} from '../../store';
import {connect} from 'react-redux';
import ErrorBox, {createErrorMessage} from '../utils/ErrorBox';
import SiteOverview from './SiteOverview';
import * as sitesApi from '../../api/sites-api';
import * as viewUtils from '../../utils/view-utils';

class SiteManagementContainer extends Component {
  constructor(props) {
    super(props);

    this.getGateways = this.getGateways.bind(this);
  }

  componentDidMount() {
    if (this.props.siteId !== null && this.props.siteId !== -1) {
      this.getGateways();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.siteId !== prevProps.siteId) {
      this.getGateways();
    }
  }

  getGateways() {
    const siteId = this.props.siteId;

    blockUtils.blockUI();
    api.setupDeviceStream(siteId).then(() => {}).catch(() => {});
  }

  getRedirectFunction(siteId) {
    blockUtils.blockUI();
    sitesApi.getHapiTokenForRedirect(siteId).then((response) => {
      blockUtils.unblockUI();
      const hapiToken = response.data;
      if (hapiToken) {
        window.open(hapiToken).focus();
      }
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  render() {
    const errorMessage = this.props.getDevicesError;

    return (
      <WhitePortlet
        caption={i18next.t('site_management.title')}
        icon="icon-settings"
        hapiLinkCallback={this.props.siteId !== -1 ? () => this.getRedirectFunction(this.props.siteId) : null}
      >
        <div className="scrolled_div">
          <div>
            {this.props.getDevicesError ?
              <ErrorBox
                key="key1"
                errorMessage={createErrorMessage(errorMessage)}
                textSize={'14px'}
                textWeight={'bold'}
              /> : null
            }

            {this.props.data && this.props.data.health ?
              <SiteOverview
                siteId={this.props.siteId}
                data={this.props.data}
                minimumFirmwareVersionString='1.2.3'
                maximumPathCost='5'
                maximumTimeDeviation='1000'
                minimumBatteryPercentage='50'
              /> :
              (!this.props.getDevicesError ?
                <ErrorBox
                  errorMessage={this.props.noSiteSelectedError}
                /> : null
              )
            }
          </div>
        </div>
      </WhitePortlet>
    );
  }
}

SiteManagementContainer.propTypes = {
  siteId: PropTypes.number,
  data: PropTypes.object,
  getDevicesError: PropTypes.string,
  noSiteSelectedError: PropTypes.string,
};

const mapStateToProps = function(store) {
  const currentSiteId = store.sitesState.currentSiteId === -1 ? selectedSiteId() : store.sitesState.currentSiteId;
  return {
    siteId: currentSiteId,
    data: store.managementState.data[currentSiteId] ? store.managementState.data[currentSiteId].data : {},
    getDevicesError: store.managementState.data[currentSiteId] ? store.managementState.data[currentSiteId].getDevicesError : null,
    noSiteSelectedError: store.managementState.getDevicesError ? '' : i18next.t('terminals.errors.select_site'),
  };
};

export default connect(mapStateToProps)(SiteManagementContainer);
